import { render, staticRenderFns } from "./PairCollectionCreator.vue?vue&type=template&id=75732748"
import script from "./PairCollectionCreator.vue?vue&type=script&setup=true&lang=ts"
export * from "./PairCollectionCreator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PairCollectionCreator.vue?vue&type=style&index=0&id=75732748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports